import React from 'react';
import styled from 'styled-components';

import { APP_VERSION } from '#/config/constants';

import { MenuItemType } from '../headerTypes';

const Wrapper = styled.div`
  padding-left: 25px;
  padding-right: 25px;

  color: var(--gray4);
  font-size: var(--small);
`;

function AppVersionMenuItemComponent() {
  return (
    <Wrapper>
      App Version
      <br />
      {APP_VERSION}
    </Wrapper>
  );
}

const AppVersionMenuItem: MenuItemType = {
  type: 'MenuBox',
  Component: AppVersionMenuItemComponent,
};

export default AppVersionMenuItem;
